var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout light"},[_c('main-header',{staticClass:"fixed",attrs:{"logo":'ms-logo-dark.svg'}}),_vm._t("default"),_c('main-footer',{staticClass:"light relative b-0 no-icons"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }